import PrintHeader from './PrintHeader';
import PrintFooter from './PrintFooter';

const PrintLayout = ({ children, headerFooterInfo, forTreatPlan = false }) => {
  return (
    <>
      <PrintHeader headerFooterInfo={headerFooterInfo} />
      {children}
      {forTreatPlan && <PrintFooter headerFooterInfo={headerFooterInfo} />}
    </>
  );
};

export default PrintLayout;
